import { Expose, Type } from 'class-transformer';
import { CreditBalanceCreditDto } from './credit-balance-credit.dto';

export class GetCreditBalanceResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'credit_id' })
  creditId: number;
  @Expose({ name: 'usage' })
  usage: number;
  @Expose({ name: 'amount' })
  amount: number;
  @Expose({ name: 'start_date' })
  startDate: number;
  @Expose({ name: 'end_date' })
  endDate: number;
  @Expose({ name: 'credit' })
  @Type(() => CreditBalanceCreditDto)
  credit: CreditBalanceCreditDto;
}
